import ReactSelect from 'react-select';

import { transparentize } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

export const OrderContainer = styled.div`
  display: flex;
  justify-content: flex-start;

  button {
    align-items: center;
    display: flex;
    font-size: 1.3rem;
    margin-left: 0.3rem;
    background: transparent;
    color: #fff;

    &:hover {
      color: ${transparentize(0.2, '#fff')};
    }
  }
`;

export const TableContainer = styled.section`
  margin: 2rem 0rem;

  table {
    width: 100%;
    border-collapse: collapse;
    /* margin: 2rem auto; */
    /* pointer-events: none; */

    tr {
      &:nth-of-type(odd) {
        background: #f3f3f3;
      }

      &:hover {
        color: #166649;
      }

      &:last-child {
        border-bottom: 3px solid #166649;
      }
    }

    th {
      background: ${props => props.theme.primaryColor};
      color: #fff;
      padding: 1.3rem 0.75rem;
      text-align: left;
      font-weight: 500;
      border: 1px solid #166649;
    }

    td {
      padding: 0rem 0.75rem;
      text-align: left;
      font-size: 16px;
      height: 5rem;
      max-width: 140px;

      ul {
        display: flex;
        /* max-width: 100px; */
        flex-wrap: wrap;

        li {
          display: inline-block;

          &:after {
            display: inline-block;
            white-space: pre;
            content: ', ';
          }

          &:last-child:after {
            display: inline-block;
            white-space: pre;
            content: '';
            color: #4285f4;
          }
        }
      }

      > .link {
        position: relative;
        transition: all 0.3s ease-in-out;
        border-bottom: 2px solid #c4c4c4;
        padding-bottom: 3px;
        cursor: pointer;

        &:hover {
          border-color: ${props => props.theme.primaryColor};
        }

        .tooltip {
          display: none;
        }

        @media (min-width: 768px) {
          .tooltip {
            display: block;
            visibility: hidden;
            background-color: #fff;
            color: #555;
            border: 1px solid #ccc;
            text-align: center;
            border-radius: 4px;
            padding: 0.4rem 1rem;
            transform: translateY(-20px);
            transition: 0.3s ease-in-out;
            opacity: 0;
            position: absolute;
            z-index: 1;
            text-transform: capitalize !important;
            font-size: 0.9rem;
            bottom: calc(100% + 15px);
            left: -10px;
            box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.1);
            white-space: nowrap;

            &:after {
              content: '';
              position: absolute;
              bottom: -11px;
              left: 45%;
              margin-top: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: #ccc transparent transparent transparent;
            }
          }

          &:hover .tooltip {
            transform: translateX(0px);
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }

    @media (max-width: 992px) {
      width: 100%;

      table,
      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
        max-width: unset;
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }

      tr {
        border: 1px solid #ccc;
        margin: 1rem 0rem;
      }

      td {
        border: none;
        border-bottom: 1px solid #eee;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        ul {
          display: flex;
          justify-content: flex-end;
          text-align: right;
        }
      }

      td:before {
        padding-right: 10px;
        content: attr(data-column);
        color: ${props => props.theme.textColor};
        font-weight: bold;
      }
    }
  }
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin: 2rem 0rem;

  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  a {
    background: ${props => props.theme.primaryColor};
    color: #fff;
    border-radius: 0.2rem;
    padding: 0.6rem 1rem;
    font-size: 1rem;
    border: 1px solid #fff;
    font-weight: 400;
    transition: 0.3s ease-in-out;
    position: relative;
    overflow: hidden;

    &:hover {
      background: ${transparentize(0.8, '#fff')};
    }
  }
`;

export const IconButton = styled.svg`
  flex: none;
  transition: fill 0.25s;
  width: 2rem;
  height: 2rem;
`;

// Paginação

export const Pagination = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const PaginationButton = styled.div`
  display: flex;
`;

interface PGProps {
  isSelect?: boolean;
}

export const PaginationItem = styled.button<PGProps>`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 35px;
  width: 35px;
  border: 1px solid #eceeef;
  color: #979797;
  display: flex;
  margin: 0px 5px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  transition: 0.3s ease-in-out;
  background: transparent;

  svg {
    width: 18px;
  }

  :not(:disabled):hover {
    color: ${props => props.theme.secondaryColor};
    border: 1px solid ${props => props.theme.secondaryColor};
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;

    :hover {
      background: transparent;
      color: #979797;
      border: 1px solid #eceeef;
    }
  }
`;

export const FooterTable = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PageSize = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const LoadingData = styled.div`
  width: 100%;
  margin: 2rem 12px;
`;

export const ReactSelectCustom = styled(ReactSelect)`
  margin-left: 1rem;
  width: 80px;

  .react-select__option {
    background: #fff;
  }

  .react-select__value-container {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    .react-select__single-value {
      color: ${props => props.theme.textColor};
    }
  }

  .react-select__control {
    &:hover,
    &:active,
    &:visited,
    &:focus-visible,
    &:focus-within,
    &:focus {
      border: 1px solid ${props => props.theme.secondaryColor};
      box-shadow: none;
    }
  }

  .react-select__option {
    background: #fff;
    color: ${props => props.theme.textColor};
    display: flex;
    align-items: center;

    &:hover {
      background: ${props => props.theme.primaryColor};
      color: #fff;
      fill: #fff;
    }

    &:hover svg {
      color: #fff;
      fill: #fff;
    }
  }

  .react-select__single-value {
    display: flex;
    align-items: center;
  }
`;
